/**
 * IAP (In-App Purchase) support — aligned with old purchase_details_common flow.
 *
 * The backend does not return 'iap' in available payment methods.
 * We use the same conditions as the old flow to decide when IAP is supported
 * and when to show it in options / add-button list.
 *
 * Purchase-type filtering: when purchaseType is in purchaseTypeToOrderType or is 'matchup_promo'
 * and supportedNewPoWallet(), IAP is disabled. Pass purchaseType when available (e.g. from
 * flow props) to avoid reading URL on every check; otherwise falls back to URL.
 */

import queryString from 'query-string';
import { toCamelCase, isPOW, fromMobileApp } from '../../../../common/config/utils';
import { supportedNewPoWallet } from '../../../../common/purchase_details_common/purchase_details_common_utils';
import { purchaseTypeToOrderType } from '../../../../common/config/const';

/** Read purchase_type from URL (camelCase: purchaseType). Same as old flow. */
export const getPurchaseTypeFromUrl = (): string | undefined => {
  const parsed = queryString.parse(window.location.search) || {};
  const camel = toCamelCase(parsed) as { purchaseType?: string };
  return camel.purchaseType;
};

const isIapDisabledForPurchaseType = (type: string | undefined): boolean => Boolean(type && (type in purchaseTypeToOrderType || type === 'matchup_promo'));

/**
 * True when IAP should be available: PO mobile app + not disabled by purchase type / version.
 * @param purchaseType - Optional; when provided used for filtering instead of reading URL.
 */
export const isIapAvailable = (purchaseType?: string): boolean => {
  if (!isPOW() || !fromMobileApp) return false;
  const effective = purchaseType ?? getPurchaseTypeFromUrl();
  return !(supportedNewPoWallet() && isIapDisabledForPurchaseType(effective));
};
